import {create} from 'zustand';
import {DisabledSelectionDateStore} from './types';

const useDisabledSelectionDateStore = create<DisabledSelectionDateStore>(set => ({
	disabledSelectionDate: false,
	setDisabledSelectionDate: value => set({disabledSelectionDate: value}),
}));

export {useDisabledSelectionDateStore};
